
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1DoRI", function(module, exports) {

$parcel$export(module.exports, "app", () => $130cb8b434adf887$export$729c8b7179294ba);
const $130cb8b434adf887$export$729c8b7179294ba = {
    user: null,
    workspace: null,
    userId: null,
    authenticatedUserId: null,
    markup: {},
    modelList: [],
    pluginList: null,
    chatListOfSession: {},
    projectListOfSession: {}
};
window.app = $130cb8b434adf887$export$729c8b7179294ba;

});


//# sourceMappingURL=appState.9c6c17e0.js.map
